// extracted by mini-css-extract-plugin
module.exports = {"picture":"picture_picture__3DSJC","logo":"picture_logo__1z0US","user":"picture_user__9Fgw0"};